







import { Vue, Component, Prop } from "vue-property-decorator";
import { mapActions, mapState, mapGetters, mapMutations } from "vuex";
import { shallowEqualObjects } from "shallow-equal";
import { Route, NavigationGuardNext } from "vue-router";
import { ROUTES_MAP } from "@/router";
import Store from "@/store";
import QS from "query-string";
import VasDetailsStandard from '@/views/vas/VasDetailsStandard.vue'
import VasDetailsWeshope from '@/views/vas/VasDetailsWeshope.vue'
import { isWishope } from "@/common/utils";

Component.registerHooks(["beforeRouteUpdate", "beforeRouteEnter"]);

const VasDetailsProps = Vue.extend({
  computed: {
    ...mapState("vas", ["saleType", "merchantDetails", "merchantShopDetails"]),
    ...mapState("global", ["cart", "checkout"]),
    ...mapGetters("vas", [
      "merchant",
      "isEnabled",
      "hasNoDeliverySlots",
      "hasDelivery",
      "requiresDeliverySlots",
      "hasAvailableSlots",
      "hasScheduledPickupAvailable",
      "availableSaleTypes",
    ]),
  },
  methods: {
    ...mapActions("vas", ["fetchMerchant"]),
    isWishope,
  },
});

@Component({
  components: {
    VasDetailsStandard,
    VasDetailsWeshope,
  },
  metaInfo() {
    return {
      meta: [
        { name: "og:title", content: (this as VasDetails).merchantShopDetails?.name },
        { name: "og:description", content: (this as VasDetails).merchantShopDetails?.description },
        { name: "og:image", content: (this as VasDetails).merchantShopDetails?._links?.hero?.href },
      ]
    };

  },
})
export default class VasDetails extends VasDetailsProps {

  isVisibleQrCodeDeeplinkModal = false;

  get progressDisabled() {
    return this.checkout && this.checkout.status === "PAYMENT_SUCCESS";
  }

  get isPaymentView() {
    return this.$route.name === "PublicVAS__payment";
  }

  get currentSaleType() {
    return this.merchant.id;
  }

  set currentSaleType(id) {
    this.setCurrentVasId(id);
  }

  setCurrentVasId(vasId: string) {
    if (String(vasId) == this.merchant.id) return null;
    if (this.$route.name) {
      this.$router.push({
        name: ROUTES_MAP.VAS_PRODUCTS,
        params: {
          ...this.$route.params,
          vasId: String(vasId),
        },
      });
    }
  }

  async beforeRouteUpdate(to: any, from: any, next: any) {
    if (!shallowEqualObjects(to.params, from.params)) {
      await this.fetchMerchant(to.params);
    }
    next();
  }

  async beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    const urlParams = QS.parse(location.search);
    const hashParams = QS.parse(location.hash.replaceAll("?", ""));

    if (urlParams["alipay_checkout"] || hashParams["alipay_checkout"]) {
      await Store.dispatch("global/fetchCheckoutWithID", {
        id: urlParams["alipay_checkout"]
          ? urlParams["alipay_checkout"]
          : hashParams["alipay_checkout"],
        isRedirect: true,
      });
    }
    await Store.dispatch("vas/fetchMerchant", to.params);
    next();
  }

  created() {

    // If VAS is closed, redirect to https://bancaprofilo.tinaba.it/
    if (this.merchantDetails && this.merchantDetails.status === 'CLOSED') {
      window.location.href = 'https://bancaprofilo.tinaba.it/';
    }
  }
}
